import { JobType } from '../../api/jobs.dao';
import { EventExecutionParams, JobDtoType } from './index';


export abstract class JobConfiguration {
    abstract readonly type: JobType;
    abstract readonly name: string;
    abstract readonly description: string;
    abstract execute(execParams: EventExecutionParams): Promise<JobDtoType>;
}
